import { render, staticRenderFns } from "./indexBanner.vue?vue&type=template&id=0a0086ba&scoped=true"
import script from "./indexBanner.vue?vue&type=script&lang=js"
export * from "./indexBanner.vue?vue&type=script&lang=js"
import style0 from "./indexBanner.vue?vue&type=style&index=0&id=0a0086ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0086ba",
  null
  
)

export default component.exports